var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_7100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4 64C21.5513 64 20.7374 63.6629 20.1373 63.0627C19.5371 62.4626 19.2 61.6487 19.2 60.8V51.2H6.4C4.70261 51.2 3.07475 50.5257 1.87452 49.3255C0.674284 48.1252 0 46.4974 0 44.8V6.4C0 4.70261 0.674284 3.07475 1.87452 1.87452C3.07475 0.674284 4.70261 0 6.4 0H57.6C59.2974 0 60.9253 0.674284 62.1255 1.87452C63.3257 3.07475 64 4.70261 64 6.4V44.8C64 46.4974 63.3257 48.1252 62.1255 49.3255C60.9253 50.5257 59.2974 51.2 57.6 51.2H38.08L26.24 63.072C25.6 63.68 24.8 64 24 64H22.4Z",
    fill: "url(#paint0_linear_455_7100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 17H36.2V12.8C36.2 11.26 34.94 10 33.4 10H30.6C29.06 10 27.8 11.26 27.8 12.8V17H20.8C19.26 17 18 18.26 18 19.8V35.2C18 36.74 19.26 38 20.8 38H43.2C44.74 38 46 36.74 46 35.2V19.8C46 18.26 44.74 17 43.2 17ZM30.6 12.8H33.4V19.8H30.6V12.8ZM30.6 29.6H27.8V32.4H25V29.6H22.2V26.8H25V24H27.8V26.8H30.6V29.6ZM33.4 27.5V25.4H41.8V27.5H33.4ZM33.4 31.7V29.6H39V31.7H33.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_7100",
    x1: 57,
    y1: -9,
    x2: 16.5,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFA73F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_7100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicoIcon);
export default __webpack_public_path__ + "static/media/ClinicoIcon.c5ce4b69b05a483f0e0acc53ecb0e5c2.svg";
export { ForwardRef as ReactComponent };